var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3C0 1.34315 1.34315 0 3 0H5C6.65685 0 8 1.34315 8 3V5C8 6.65685 6.65685 8 5 8H3C1.34315 8 0 6.65685 0 5V3ZM3 2C2.44772 2 2 2.44772 2 3V5C2 5.55228 2.44772 6 3 6H5C5.55228 6 6 5.55228 6 5V3C6 2.44772 5.55228 2 5 2H3ZM10 3C10 1.34315 11.3431 0 13 0H15C16.6569 0 18 1.34315 18 3V5C18 6.65685 16.6569 8 15 8H13C11.3431 8 10 6.65685 10 5V3ZM13 2C12.4477 2 12 2.44772 12 3V5C12 5.55228 12.4477 6 13 6H15C15.5523 6 16 5.55228 16 5V3C16 2.44772 15.5523 2 15 2H13ZM0 13C0 11.3431 1.34315 10 3 10H5C6.65685 10 8 11.3431 8 13V15C8 16.6569 6.65685 18 5 18H3C1.34315 18 0 16.6569 0 15V13ZM3 12C2.44772 12 2 12.4477 2 13V15C2 15.5523 2.44772 16 3 16H5C5.55228 16 6 15.5523 6 15V13C6 12.4477 5.55228 12 5 12H3ZM10 13C10 11.3431 11.3431 10 13 10H15C16.6569 10 18 11.3431 18 13V15C18 16.6569 16.6569 18 15 18H13C11.3431 18 10 16.6569 10 15V13ZM13 12C12.4477 12 12 12.4477 12 13V15C12 15.5523 12.4477 16 13 16H15C15.5523 16 16 15.5523 16 15V13C16 12.4477 15.5523 12 15 12H13Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.9b784460af3f9ad62a1fa55506b1a8a7.svg";
export { ForwardRef as ReactComponent };